<template>
  <div class="row mt-2 justify-content-xl-between">
    <div class="col form-group col-md-3 col-12">
      <select
        class="form-control"
        @change="$event => changePageSize(Number($event.target.value))"
      >
        <option value="10">
          {{ $t('selects.10per') }}
        </option>
        <option value="15">
          {{ $t('selects.15per') }}
        </option>
        <option value="20">
          {{ $t('selects.20per') }}
        </option>
        <option value="50">
          {{ $t('selects.50per') }}
        </option>
      </select>
    </div>
    <div class="text-right col-12 col-md-9 offset-lg-2 col-lg-7 pagination-controls">
      <div class="row">
        <span class="d-block col-12 col-md-3">
          <button
                  :disabled="currentPage == 1"
                  class="d-block w-100 btn btn-secondary "
                  @click="changePageNumber(currentPage - 1)"
          >
             {{ $t('buttons.previous') }}
         </button>
        </span>
        <div class="col-12 col-md-6">
          <div class="row pages-container">
            <span class="text-center col-3" v-if="currentPage > 2">
              <button
                class="first-last-page-btn btn btn-secondary mx-1"
                @click="changePageNumber(1)"
              >
                1
              </button>
            </span>
            <span class="real-pages col-6 text-center">
              <button
                v-for="i in displayNumbers"
                :key="i"
                class="btn"
                :class="{ 'btn-primary': i == currentPage }"
                @click="changePageNumber(i)"
              >
                {{ i }}
              </button>
            </span>
            <span class="col-3" v-if="currentPage <= numberOfPages - 4">
              <button
                class="btn btn-secondary mx-1 d-block first-last-page-btn"
                @click="changePageNumber(numberOfPages - 1)"
              >
                {{ numberOfPages - 1 }}
              </button>
            </span>
          </div>
        </div>
        <span class="d-block col-12 col-md-3">
           <button
                   :disabled="currentPage >= numberOfPages - 1"
                   class="d-block w-100 btn btn-secondary"
                   @click="changePageNumber(currentPage + 1)"
           >
        {{ $t('buttons.next') }}
      </button>
        </span>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageControls',
  props: {
    numberOfPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: false,
      default: 1,
    }
  },
  computed: {
    pageNumbers() {
      return [...Array(this.numberOfPages).keys()].slice(1)
    },
    displayNumbers() {
      return this.pageNumbers.slice(Math.max(this.currentPage - 2, 0), Math.min(this.currentPage + 2, this.pageNumbers.length))
    }
  },
  methods: {
    changePageNumber(number) {
      this.$emit('pageChange', number);
    },
    changePageSize(number) {
      this.$emit('sizeChange', number);
    }
  }
};
</script>
